const faCheckCircle = {
  prefix: 'fal',
  iconName: 'circle-check',
  icon: [
    512,
    512,
    [61533, 'check-circle'],
    'f058',
    'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm77.6-311.5c4.7-7.5 2.4-17.4-5.1-22s-17.4-2.4-22 5.1l-67.6 108.2-34-45.3c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4l48 64c3.2 4.2 8.2 6.6 13.5 6.4s10.1-3 12.9-7.5l80-128z',
  ],
};
export default faCheckCircle;
